<!-- 由 suu 创建于 2022-01-24 星期一 -->
<template>
  <div class="ques-feedback">
    <img
      class="qf-icon-1"
      src="	https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/camp_stage_icon_1"
      alt=""
    />
    <img
      class="qf-icon-2"
      src="	https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/camp_stage_icon_2"
      alt=""
    />
    <div
      class="qf-item"
      v-for="(item, index) in info"
      :key="index"
      :class="['qf-item-' + item.size]"
    >
      {{ item.text }}
    </div>
    <div class="qf-btn user-btn" @click="handelNext">
      {{ final ? '完成并领取奖励' : '下一题' }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ques-feedback',

  components: {},

  props: {
    info: {},
    final: {}
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    // 继续下一题
    handelNext() {
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.ques-feedback {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #fff;
  z-index: 10;
  padding: 110px 38px;
  padding-top: 145px;
  box-sizing: border-box;
  .qf-icon-1 {
    width: 206px;
    position: absolute;
    right: 0;
    top: 0;
  }
  .qf-icon-2 {
    width: 45px;
    position: absolute;
    top: 96px;
    left: 38px;
  }
  .qf-item-1 {
    font-size: 28px;
    font-weight: bold;
    color: #3a69ef;
    line-height: 36px;
    margin-bottom: 29px;
  }
  .qf-item-1 + .qf-item-1 {
    margin-top: -29px;
  }
  .qf-item-2 {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
  }
  .qf-item-3 {
    line-height: 26px;
    font-size: 14px;
  }
  .qf-item-4 {
    font-size: 12px;
    padding: 12px 0;
    border-top: 1px dashed #3a69ef;
    border-bottom: 1px dashed #3a69ef;
    font-weight: 500;
    line-height: 24px;
    margin-top: 40px;
  }
  .qf-item-5 {
    font-size: 20px;
    color: #3a69ef;
    margin-top: 50px;
    font-weight: 600;
  }
  .qf-btn {
    width: 257px;
    height: 40px;
    background: linear-gradient(270deg, #5b86f5 0%, #3764e6 100%);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
